import { CalendarClock, Car, User } from 'lucide-react';
import { CandidateSlot } from '../types';
import { durationLabel, slotLabel } from '../lib/format';
import { Button } from './charte';
import { Sheet } from './shell/Sheet';

/** Confirmation d'une réservation (charte) : monte du bas sur téléphone, centrée sur ordinateur. */
export default function ReserveModal({
  slot,
  schoolName,
  submitting,
  error,
  onConfirm,
  onClose,
}: {
  slot: CandidateSlot;
  schoolName: string | null;
  submitting: boolean;
  error: string | null;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const rows = [
    { icon: CalendarClock, text: <span className="font-semibold text-heading">{slotLabel(slot.startsAt, slot.endsAt)}</span> },
    {
      icon: User,
      text: (
        <>
          Moniteur : <span className="font-semibold text-heading">{slot.instructorName ?? 'À confirmer'}</span>
        </>
      ),
    },
    { icon: Car, text: <>{durationLabel(slot.startsAt, slot.endsAt)} · Décomptée de votre forfait</> },
  ];
  return (
    <Sheet
      title="Confirmer la réservation"
      description={`Leçon de conduite${schoolName ? ` · ${schoolName}` : ''}`}
      onClose={onClose}
      footer={
        <>
          <Button className="flex-1" onClick={onClose}>
            Annuler
          </Button>
          <Button variant="primary" className="flex-1" loading={submitting} onClick={onConfirm}>
            Confirmer
          </Button>
        </>
      }
    >
      <ul className="grid gap-3 rounded-row bg-surface-light p-4">
        {rows.map(({ icon: Icon, text }, i) => (
          <li key={i} className="flex items-center gap-3 text-sm text-body">
            <span className="grid h-8 w-8 shrink-0 place-items-center rounded-xl bg-white text-primary shadow-navbar">
              <Icon size={16} aria-hidden />
            </span>
            <span>{text}</span>
          </li>
        ))}
      </ul>
      <p className="mt-4 text-sm text-secondary">Votre réservation sera confirmée instantanément et votre moniteur sera prévenu.</p>
      {error && (
        <p className="mt-3 rounded-xl bg-danger-light px-3 py-2 text-sm text-danger-dark" role="alert">
          {error}
        </p>
      )}
    </Sheet>
  );
}
